import FloatingEdge from "./FloatingEdge";
import PlaceholderEdge from "./PlaceholderEdge";
import WorkflowEdge from "./WorkflowEdge";

export const createEdgeTypes = (takeSnapshot: () => void): any => {
  return {
    placeholder: (props: any) => <PlaceholderEdge {...props} />,
    workflow: (props: any) => (
      <WorkflowEdge {...props} takeSnapshot={takeSnapshot} />
    ),
    floating: (props: any) => <FloatingEdge {...props} />,
  };
};
